var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('TheHeader'),_c('TheBanner'),_c('TheIntro'),_c('TheSection'),_c('TheFaq'),_c('TheVideo'),_c('TheNews'),_c('AdditionBtn'),_c('TheFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }